"use strict"

const createStore = require("@cirrus/legacy/app-common/framework/utils/createStore.es6").default

let _depth = "",
  _locationHash = "",
  _breadcrumb = "",
  _customTrigger = null,
  _hidden = false,
  _pageEditable = false,
  _backText = ""
const BackButtonStore = createStore("BackButtonStore", {
  getDepth () {
    return _depth
  },
  getLocationHash () {
    return _locationHash
  },
  getPageEditable () {
    return _pageEditable
  },
  getCustomTrigger () {
    return _customTrigger
  },
  getHidden () {
    return _hidden
  },
  getBreadcrumb () {
    return _breadcrumb
  },
  getBackText () {
    return _backText
  },
  handlers: {
    "GO_BACK:MANUAL": "manualGoBack",
    "GO_BACK:BREADCRUMBS_CHANGED": "breadcrumbsChanged",
    "GO_BACK:REMOVE_BACK_BUTTON": "breadcrumbsChanged",
    "GO_BACK:PAGE_EDITABLE": "updatePageEditable",
    "GO_BACK:CUSTOM_TRIGGER": "customTrigger",
    "GO_BACK:CHANGE_VISIBILITY": "changeVisibility",
    "GO_BACK:RESET_VISIBILITY": "resetVisibility",
    "GO_BACK:UPDATE_BACK_TEXT": "updateBackText",
  },
  manualGoBack () {
    document.location.hash = _locationHash
  },
  breadcrumbsChanged (state) {
    if (state.data.hasOwnProperty("backText")) {
      _backText = state.data.backText
    }

    if (state.data.bc) {
      _pageEditable = state.data.editable
      _breadcrumb = state.data.bc
      _depth = _breadcrumb.length

      if (_depth > 1 && _breadcrumb[_depth - 2].url) {
        _locationHash = _breadcrumb[_depth - 2].url
      }
    }

    this.__emitChange()
  },
  updatePageEditable (state) {
    _pageEditable = state.data.editable
    _hidden = state.data.hidden

    this.__emitChange()
  },
  customTrigger (state) {
    _pageEditable = state.data.editable
    _customTrigger = state.data.trigger

    this.__emitChange()
  },
  changeVisibility (payload) {
    _hidden = payload.data.hidden

    if (payload.data.hasOwnProperty("backText")) {
      _backText = payload.data.backText
    }

    this.__emitChange()
  },
  resetVisibility () {
    _hidden = false
    _backText = ""

    this.__emitChange()
  },
  updateBackText (payload) {
    _backText = payload.data.backText
    _hidden = false

    this.__emitChange()
  },
})
module.exports = BackButtonStore
